<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>计划发布</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form
        :inline="true"
        :model="searchFrom"
        ref="searchFrom"
        class="demo-form-inline"
        label-width="110px"
        size="mini"
      >
        <div class="inpBox">
          <el-form-item label="采购订单号:" prop="orderID">
            <el-input
              placeholder=""
              maxlength="100"
              v-model="searchFrom.purorderNo"
            ></el-input>
          </el-form-item>
          <el-form-item label="采购日计划号:" prop="orderID">
            <el-input
              placeholder=""
              maxlength="100"
              v-model="searchFrom.purplanNo"
            ></el-input>
          </el-form-item>
          <el-form-item label="供应商:" prop="supplier">
            <el-input
              placeholder=""
              maxlength="100"
              v-model="searchFrom.fromOrg"
            ></el-input>
          </el-form-item>
          <el-form-item label="物料名称:" prop="materialName">
            <el-input
              placeholder=""
              maxlength="100"
              v-model="searchFrom.goodsName"
            ></el-input>
          </el-form-item>
          <el-form-item label="计划状态:" prop="planStatus">
            <el-select v-model="searchFrom.purplanStatus" placeholder="请选择">
              <el-option
                v-for="(item, index) in planStatusOptions"
                :key="index"
                :label="item.showName"
                :value="item.purplanStatus"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交货日期:" prop="deliveryDate">
            <el-date-picker
              v-model="searchFrom.startTime"
              size="mini"
              style="width: 190px"
              placeholder="选择日期"
              type="date"
              value-format="yyyy-MM-dd"
            ></el-date-picker>&nbsp;-&nbsp;&nbsp;
            <el-date-picker
              v-model="searchFrom.endTime"
              size="mini"
              style="width: 190px"
              placeholder="选择日期"
              type="date"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" @click="searchClick" btnCode="001P001B001" v-if="btnFlg[0]">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="chongZhiClick" btnCode="001P001B002" v-if="btnFlg[1]">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addBtnClick" btnCode="001P001B003" v-if="btnFlg[2]">获取计划</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="changeBtnClick" btnCode="001P001B004" v-if="btnFlg[3]">编辑计划</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="releaseClick" btnCode="001P001B005" v-if="btnFlg[4]">发布</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="quXiaoReleaseClick" btnCode="001P001B006" v-if="btnFlg[5]">撤销发布</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }" v-loading='tabLoading'>
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%; margin-top: 10px"
        center
        @row-click="handleRowClick"
        @current-change="handleTabCurrentChange"
        :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        :header-row-style="{ height: '45px' }"
        :row-style="{ height: '35px' }"
        highlight-current-row
      >
        <el-table-column type="selection" width="55" align="center" ></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="customerName" label="操作" width="180" align="center" >
          <template slot-scope="scope"><div>
            <el-button @click="completionStatus(scope.row)" type="primary" size="small" btnCode="001P001B007" v-if="btnFlg[6]">完成情况</el-button>
            <el-button  v-if="scope.row.purplanStatus != 1 && scope.row.purplanStatus != 3 && btnFlg[7]" @click="lockClick(scope.row)" type="success" size="small" btnCode="001P001B008">锁定</el-button>
            <el-button  v-if="scope.row.purplanStatus ==3 && btnFlg[8]" @click="unlockClick(scope.row)" type="danger" size="small"  btnCode="001P001B009">解锁</el-button>
          </div></template>
        </el-table-column>
        <el-table-column prop="pStatusName" label="状态" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="purorderNo" label="采购订单号" align="center" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="purplanNo" label="采购日计划号" align="center" width="230" show-overflow-tooltip></el-table-column>
        <el-table-column prop="goodsName" label="物料名称" align="center" width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="goodsNo" label="物料编码" align="center" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="purplanWeight" label="采购吨数" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="accomplished" width="130" label="已完成吨数" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="toOrg" label="收货单位" align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="warehouseNameShow" label="收货仓库" align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="areaName" label="收货库位" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="fromOrg" label="供应商" align="center" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="validDate" label="交货日期" align="center" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="wharfName" label="港口" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="forwarderName" label="货代" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="shipName" label="船名" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="createUser" label="创建人" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateUser" label="修改人" align="center"  show-overflow-tooltip :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="updateTime" label="修改时间" align="center" width="180" show-overflow-tooltip :formatter="formatterRowEmpty"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 编辑计划 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="changeMark"
    width="1100px"
    center>
      <div v-loading='loading'>
      <div class="bigBox">
        <el-form
          :model="changeFrom"
          :validate-on-rule-change = "false"
          :inline="true"
          ref="changeFrom"
          class="demo-form-inline"
          label-width="110px" size="mini">
        <div class="" style="margin-left:-25px;">
          <el-form-item label="采购订单号:" prop="" style="margin-top:10px;">
            <span>{{changeFrom.purorderNo}}</span>
          </el-form-item>
           <el-form-item label="采购日计划号:" prop="" style="margin-top:10px;">
            <span>{{changeFrom.purplanNo}}</span>
          </el-form-item>
          <hr>
          <el-form-item label="物料名称:" prop="goodsName" style="margin-top:10px;">
            <el-input placeholder="" maxlength="" :disabled='true' v-model.trim="changeFrom.goodsName" style="width:150px;"></el-input>
          </el-form-item>
          <el-form-item label="物料编码:" prop="goodsNo" style="margin-top:10px;">
            <el-input placeholder="" maxlength="" :disabled='true' v-model.trim="changeFrom.goodsNo" style="width:150px;"></el-input>
          </el-form-item>
          <el-form-item label="采购吨数:" prop="purplanWeight" style="margin-top:10px;" class="is-required">
            <el-input placeholder="" maxlength=""  v-model.trim="changeFrom.purplanWeight" style="width:150px;"></el-input>
          </el-form-item>
          <el-form-item label="交货日期:" prop="startTime" style="margin-top:10px;">
            <el-date-picker
              v-model="changeFrom.startTime"
              size="mini"
              style="width: 150px"
              placeholder="选择日期"
              type="date"
              :disabled='true'
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="港口:" prop="wharfName" style="margin-top:10px;" class="is-required" >
            <el-select v-model="changeFrom.wharfName" :disabled='true' placeholder="请选择" @change="change1" style="width:150px;">
              <el-option
                v-for="(item,index) in portOptions"
                :key="index"
                :label="item.showName"
                :value="item.itemNo">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="船名:" prop="shipName" style="margin-top:10px;">
            <el-input placeholder="" maxlength=""  v-model.trim="changeFrom.shipName" style="width:150px;"></el-input>
          </el-form-item>
          <el-form-item label="港口计划号:" prop="planTempid" style="margin-top:10px;">
            <el-select v-model="changeFrom.planTempid" placeholder="请选择" style="width:150px;" @change="change">
              <el-option
                v-for="(item,index) in plantNoByShipName"
                :key="index"
                :label="item.planNo"
                :value="item.planTempid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商:" prop="fromOrg" style="margin-top:10px;" class="is-required">
            <el-input placeholder="" maxlength="" :disabled='true'  v-model.trim="changeFrom.fromOrg" style="width:150px;"></el-input>
          </el-form-item>
          <el-form-item label="货代:" prop="forwarderName" style="margin-top:10px;">
            <el-input placeholder="" maxlength=""  v-model.trim="changeFrom.forwarderName" style="width:150px;"></el-input>
          </el-form-item>
        </div>
        </el-form>
        <hr>
        <el-button type="primary" @click="addFenPeiTab()" class="addstyle">新增</el-button>
        <div>
          <el-table
            :data="changeTableList"
            ref="changeTableList"
            border
            bordersize="mini"
            style="width: 100%;margin-top:10px;"
            center
            :header-cell-style="{background:'#F5F5F5',color:'black'}"
            :header-row-style="{height:'45px'}"
            :row-style="{height:'35px'}"
            highlight-current-row>
            <el-table-column prop="warehouse" label="收货仓库" align="center">
              <template slot-scope="scope"><div>
                <el-select v-model="scope.row.warehouse" placeholder="请选择" size="mini" style="width:150px;">
                  <el-option
                    v-for="(item,index) in stockInf"
                    :key="index"
                    :label="item.warehouseName"
                    :value="item.warehouse">
                  </el-option>
                </el-select>
              </div></template>
            </el-table-column>
            <!--<el-table-column prop="purplanWarehouseId" label="111"  align="center" ></el-table-column>-->
            <el-table-column prop="weight" label="卸货吨位"  align="center" >
              <template slot-scope="scope"><div>
                <el-input  placeholder="" v-number-input.float="3" maxlength="100" v-model="scope.row.weight" size="mini" style="width:150px;"></el-input>
              </div></template>
            </el-table-column>
            <el-table-column prop="" label="操作" width="120" align="center" >
              <template slot-scope="scope"><div>
                <span v-if="scope.$index == 0">-</span>
                <el-button v-else @click.native.prevent="delData(scope.$index, scope.row)" type="text" size="small">删除</el-button>
              </div></template>
            </el-table-column>
          </el-table>
        </div>
    <!--  表格 -->
    <hr>
    <div style="display:flex;">
      <div>备注：</div>
      <div>
        <el-input type="textarea" style="width:500px;" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="remark"></el-input>
      </div>
    </div>
      </div>
      <div  style="width:130px;margin:15px auto;">
         <el-button type="primary" @click="submitForm" size='mini'>保存</el-button>
        <el-button @click="changeResetForm" size='mini'>取消</el-button>
      </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getDictionaryList, // 字典
  publishPlan, // 发布
  revocationPlan, // 取消发布
  getPurchasePlanList, // 计划发布页面的获取计划发布列表
  getPurPlanStatusList, // 计划状态列表
  lockPurchasePlan, // 锁定计划
  unlockPurchasePlan, // 解锁计划
  getPurchasePlanInfo, // 编辑计划
  savePlan, // 编辑计划保存
  delPurplanWarehouse // 计划编辑删除
} from '@/api/zhb-sgHarbour.js'
import { getBtn } from '@/utils/getButton'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
export default {
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnIdArr: [
        '001P001B001',
        '001P001B002',
        '001P001B003',
        '001P001B004',
        '001P001B005',
        '001P001B006',
        '001P001B007',
        '001P001B008',
        '001P001B009'
      ],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10,
        collectPlanTime: '',
        purorderNo: '',
        purplanNo: '',
        fromOrg: '',
        planStatus: '',
        goodsName: '',
        purplanStatus: '',
        startTime: '',
        endTime: ''
      },
      planStatusOptions: [],
      value: '',
      tableList: [],
      tabLoading: false,
      // 新增
      addShengChengLoading: false,
      addFaBuLoading: false,
      // 修改
      changeFlag: '', // 1自动  2 手动
      changeData: {}, // 修改需携带的数据
      faBuId: '',
      changeMark: false,
      changeTableList: [],
      changeFrom: {
        id: '', // 采购计划ID
        purorderNo: '', // 采购订单号
        purplanNo: '', // 采购日计划号
        goodsName: '', // 物料名称
        goodsNo: '', // 物料编码
        purplanWeight: '', // 采购吨数
        startTime: '', // 交货日期
        shipName: '', // 船名
        fromOrg: '', // 供应商
        forwarderName: '', // 货代
        wharfName: '', // 港口
        wharfId: '', // 港口ID
        // planNo:'', //
        planTempid: '', // 疏港计划ID
        warehouse: [] // 收货仓库
      },
      remark: '', // 备注
      plantNoByShipName: [],
      stockInf: [],
      loading: false,
      portOptions: [], // 港口
      // rules:{
      //   materialName: [
      //     { required: true, message: '请输入物料名称', trigger: 'blur' }
      //   ],
      //   deliveryDate: [
      //     { required: true, message: '请选择交货日期', trigger: 'blur' }
      //   ],
      //   purplanWeight: [
      //     { required: true, message: '请输入采购吨数', trigger: 'blur' }
      //   ],
      //   fromOrg: [
      //     { required: true, message: '请输入供应商', trigger: 'blur' }
      //   ],
      //   fromOrg: [
      //     { required: true, message: '请输入供应商', trigger: 'blur' }
      //   ],
      //   wharfName:[
      //     { required: true, message: '请选择港口', trigger: 'blur' }
      //   ]
      // },
      baoCunData: [],
      delIsShow: false, // 第一条不显示删除按钮
      warehouseNameShow: ''
    }
  },
  created () {
    this.getToDay()
    this.btnFlg = getBtn(this.btnIdArr, '/sgPlanManagement/planRelease')
    this.getSeatchData(this.searchFrom)
    this.purPlanStatusList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 150 + 'px'
  },
  methods: {
    // 时间格式化
    timeStamp (value) { // 具体到时分秒
      var date = new Date(value) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var sdate = ('0' + date.getDate()).slice(-2)
      var hour = ('0' + date.getHours()).slice(-2)
      var minute = ('0' + date.getMinutes()).slice(-2)
      var second = ('0' + date.getSeconds()).slice(-2)
      // 拼接
      var result = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute + ':' + second
      // 返回
      return result
    },
    // 年月日
    timeStamp2 (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log("time:" + JSON.stringify(now));
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    // 字典
    getDictionaryList () {
      getDictionaryList({
        groupNo: 'wharf'
      }).then(res => {
        this.portOptions = res.wharf // 港口
        // this.portOptions.unshift({'itemNo':'','showName':'全部'})
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 计划开始时间-当前日期早8点
    getToDay () {
      // 早八点之前显示昨天的日期，早八点之后显示今天的日期
      let dateStartStr = this.timeStamp2(new Date(new Date(new Date().toLocaleDateString()).getTime())) // 当天的早8点时间戳
      let dateEndStr = this.timeStamp2(new Date(new Date(new Date().toLocaleDateString()).getTime() + 43200000 * 3 - 14400000)) // 当天的早8点时间戳
      // console.log(this.timeStamp2(new Date(dateStartStr).getTime()-86400000),'333')   // 早八点时间戳
      let morningTime = new Date(dateStartStr).getTime()
      this.searchFrom.startTime = this.timeStamp2(new Date(dateStartStr).getTime())
      this.searchFrom.endTime = this.timeStamp2(new Date(dateStartStr).getTime() + 86400000)
      // 昨天的时间
      // this.searchFrom1.sendCarStartTime = this.timeStamp2(new Date(dateStartStr).getTime()-86400000)
      // this.searchFrom1.sendCarEndTime = this.timeStamp2(new Date(dateStartStr).getTime())
    },
    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      getPurchasePlanList(this.searchFrom)
        .then((res) => {
          this.tabLoading = false
          this.tableList = res.list
          this.total = res.total
        })
        .catch((err) => {
          this.tabLoading = false
          // console.log(err.message)
          this.$message.error(err.message)
        })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData(this.searchFrom)
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10,
        purplanStatus: '',
        startTime: '',
        endTime: ''
      }
      this.getToDay()
      this.getSeatchData(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row) {
      // console.log(row)
      this.$refs.tableRef.toggleRowSelection(row)
      this.changeFlag = row.newFlg
      this.changeData = row
      this.faBuId = row.id
      this.planStatus = row.planStatus
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 判断数组的每一项是否等于待发布
    isAllEqual2 (array) {
      if (array.length > 0) {
        return !array.some(function (value, index) {
          return value !== '1'
        })
      } else {
        return true
      }
    },
    isAllEqual3 (array) {
      if (array.length > 0) {
        return !array.some(function (value, index) {
          return value !== '2'
        })
      } else {
        return true
      }
    },
    isAllEqual4 (array) {
      if (array.length > 0) {
        return !array.some(function (value, index) {
          return value !== '2'
        })
      } else {
        return true
      }
    },
    // 点击发布按钮
    releaseClick () {
      let selectData = this.$refs.tableRef.selection
      if (selectData.length < 1) {
        this.$message.error('请选择一条数据进行操作')
      } else {
        let planIds = []
        let purplanStatusArr = []
        let operFlagArr = []
        for (let i = 0; i < selectData.length; i++) {
          purplanStatusArr.push(selectData[i].purplanStatus)
          operFlagArr.push(selectData[i].operFlag)
        }
        if (this.isAllEqual2(purplanStatusArr) != false) {
          if (this.isAllEqual3(operFlagArr) == false) {
            this.$message.error('信息不完整,请先补全信息,再发布!')
          } else {
            for (let a = 0; a < selectData.length; a++) {
              planIds.push(selectData[a].purchasePlanId)
            }
            this.$confirm('是否要执行发布操作?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => {
              publishPlan(planIds).then(res => {
                this.$message.success('计划发布成功')
                this.getSeatchData(this.searchFrom)
              }).catch(err => {
                this.$message.error(err.message)
              })
            }).catch(() => {
              // this.$message.success("已取消发布操作")
            })
          }
        } else {
          this.$message.error('请选择待发布的计划!')
        }
      }
    },
    // 点击撤销发布
    quXiaoReleaseClick () {
      let selectData = this.$refs.tableRef.selection
      if (selectData.length < 1) {
        this.$message.error('请选择一行数据进行操作')
      } else {
        let planId = ''
        let purplanStatusArr = []
        for (let i = 0; i < selectData.length; i++) {
          purplanStatusArr.push(selectData[i].purplanStatus)
        }
        if (this.isAllEqual4(purplanStatusArr) != false) {
          planId = selectData[0].purchasePlanId
          this.$confirm('是否要执行撤销发布操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            revocationPlan(planId).then(res => {
              this.$message.success('撤销发布计划成功')
              this.getSeatchData(this.searchFrom)
            }).catch(err => {
              this.$message.error(err.message)
            })
          }).catch(() => {
            // this.$message.success("操作已撤销")
          })
        } else {
          this.$message.error('只能撤销已发布的计划!')
        }
      }
    },
    // 点击获取计划按钮
    addBtnClick () {
      this.$router.push('/sgPlanManagement/getSGPlan')
    },
    // 合同列表取消
    heTongQuXiaoClick () {
      this.heTongMark = false
    },
    // 每页条数
    handleSizeChange2 (val) {
      this.heTongFrom.pageSize = val
      // this.getSearchData()
    },
    // 当前页
    handleCurrentChange2 (val) {
      this.heTongFrom.pageNo = val
      // this.getSearchData()
    },
    // 锁定计划
    lockClick (row) {
      if (row == null || row == '') {
        this.$message.error('请选择一条数据进行操作')
        return
      }
      if (row.purplanStatus == 2 || row.purplanStatus == 6) {
        lockPurchasePlan(row).then(res => {
          this.$message.success('计划锁定成功')
          this.getSeatchData(this.searchFrom)
        }).catch(err => {
          this.$message.error(err.message)
        })
      } else {
        this.$message.error(`计划状态为【${row.purplanStatus}】的计划不能锁定`)
      }
    },
    // 解锁计划
    unlockClick (row) {
      if (row == null || row == '') {
        this.$message.error('请选择一条数据进行操作')
        return
      }
      if (row.purplanStatus == 3) {
        unlockPurchasePlan(row).then(res => {
          this.$message.success('计划解锁成功')
          this.getSeatchData(this.searchFrom)
        }).catch(err => {
          this.$message.error(err.message)
        })
      } else {
        this.$message.error('只能解锁已锁定的计划')
      }
    },
    // 获取计划状态列表
    purPlanStatusList () {
      getPurPlanStatusList()
        .then((res) => {
          // console.log(res)
          this.planStatusOptions = res
          this.planStatusOptions.unshift({ 'purplanStatus': '', 'showName': '全部' })
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 点击完成情况
    completionStatus (row) {
      localStorage.setItem('purchasePlan', JSON.stringify(row))
      this.$router.push('/sgPlanManagement/completionStatus')

      // this.$router.push({
      //   name: "completionStatus",
      //   params: {
      //     purchasePlan: row
      //   },
      // })
    },
    // ----------------编辑计划---------------
    // 点击编辑计划添加
    addFenPeiTab () {
      var list = {
        warehouse: this.stockInf[0].warehouse,
        purplanWarehouseId: '',
        weight: ''
      }
      // this.$set(list, 'warehouse', this.stockInf[0].warehouseName)
      this.changeTableList.push(list)
    },
    // 删除表格行
    delData (index, rows) {
      let purplanWarehouseId = rows.id
      // console.log(purplanWarehouseId,'purplanWarehouseId')
      if (purplanWarehouseId != null && purplanWarehouseId != undefined && purplanWarehouseId != '') {
        this.$confirm(
          `您确定要删除收货仓库【${rows.warehouseName}】吗？`,
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'waring'
          }
        ).then(() => {
          let params = {
            purchasePlanId: rows.purchasePlanId,
            purplanWarehouseId: rows.id
          }
          delPurplanWarehouse(params).then(res => {
            this.changeTableList.splice(index, 1)
            this.$message.success('删除成功')
          }).catch(err => {
            this.$message.error(err.message)
          })
        }).catch(() => {
          this.$message.info('已取消删除')
        })
      } else {
        this.changeTableList.splice(index, 1)
      }
    },
    // 港口计划号下拉框改变
    change () {
      this.$forceUpdate()
    },
    // 港口下拉框改变
    change1 () {
      this.$forceUpdate()
    },
    // 点击编辑按钮
    changeBtnClick () {
      let selectData = this.$refs.tableRef.selection
      let planIds = []
      if (selectData.length < 1) {
        this.$message.error('请选择一条待发布、已发布或已分配的计划进行编辑')
      } else if (selectData.length > 1) {
        this.$message.error('只能选择一条待发布、已发布或已分配的计划进行编辑')
      } else {
        if (selectData[0].purplanStatus == 1 || selectData[0].purplanStatus == 2 || selectData[0].purplanStatus == 6) {
          this.changeMark = true
          this.title = '计划编辑'
          this.loading = true
          this.warehouseNameShow = selectData[0].warehouseNameShow
          this.getDictionaryList()
          getPurchasePlanInfo({
            purchasePlanId: selectData[0].purchasePlanId,
            warehouseNameShow: selectData[0].warehouseNameShow
          }).then(res => {
            this.loading = false
            this.changeFrom = {}
            this.changeFrom.purplanNo = res.tPurchasePlan.purplanNo
            this.changeFrom.purorderNo = res.tPurchasePlan.purorderNo

            this.$set(this.changeFrom, 'goodsName', res.tPurchasePlan.goodsName)
            this.$set(this.changeFrom, 'goodsNo', res.tPurchasePlan.goodsNo)
            this.$set(this.changeFrom, 'purplanWeight', res.tPurchasePlan.purplanWeight)
            this.$set(this.changeFrom, 'startTime', this.timeStamp2(res.tPurchasePlan.validDate))
            this.$set(this.changeFrom, 'shipName', res.tPurchasePlan.shipName)
            this.$set(this.changeFrom, 'fromOrg', res.tPurchasePlan.fromOrg)
            this.$set(this.changeFrom, 'forwarderName', res.tPurchasePlan.forwarderName)
            this.$set(this.changeFrom, 'wharfName', res.tPurchasePlan.wharfId)
            this.$set(this.changeFrom, 'id', res.tPurchasePlan.id)
            this.$set(this.changeFrom, 'planTempid', res.tPurchasePlan.planTempid)
            this.$set(this.changeFrom, 'validDate', res.tPurchasePlan.validDate)
            // this.$set(this.changeFrom, 'planTempid', res.tPurchasePlan.planNo)
            // this.changeFrom.planNo=res.tPurchasePlan.planNo
            this.remark = res.tPurchasePlan.remark
            // 列表下拉框
            this.stockInf = res.stockInf
            // 列表
            this.changeTableList = []
            // if(res.ppWhList.length == '0' && res.plantIdss == undefined){
            //   var list = {
            //     warehouse: this.stockInf[0].warehouse,
            //     purplanWarehouseId: '',
            //     weight: ''
            //   }
            //   this.changeTableList.push(list)
            // }else{
            //   var list = {
            //     warehouse: res.plantIdss,
            //     purplanWarehouseId: '',
            //     weight: ''
            //   }
            //   this.changeTableList.push(list)
            // }
            if (res.ppWhList.length == '0') {
              if (res.plantIdss != undefined || res.plantIdss != null || res.plantIdss != '') {
                var list = {
                  warehouse: res.plantIdss,
                  purplanWarehouseId: '',
                  weight: ''
                }
                this.changeTableList.push(list)
              } else {
                var list = {
                  warehouse: this.stockInf[0].warehouse,
                  purplanWarehouseId: '',
                  weight: ''
                }
                this.changeTableList.push(list)
              }
            } else {
              this.changeTableList = res.ppWhList
            }

            this.plantNoByShipName = res.plantNoByShipName
            this.plantNoByShipName.unshift({ 'planTempid': '', 'planNo': '全部' })
          }).catch(err => {
            this.loading = false
            this.$message.error(err.message)
          })
        } else {
          this.$message.error('只能选择待发布、已发布或已分配的计划进行编辑')
        }
      }
    },
    // 验证重复元素，有重复返回true；否则返回false
    isRepeat (arr) {
      var hash = {}
      for (var i in arr) {
        if (hash[arr[i]]) {
          return true
        }
        // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
        hash[arr[i]] = true
      }
      return false
    },
    // 数组求和
    sum (arr) {
      var s = 0
      arr.forEach(function (val, idx, arr) {
        s += val
      }, 0)
      return s
    },
    // 点击计划编辑保存
    submitForm () {
      this.changeFrom.warehouse = [] // 将收货仓库重新设为空
      if (this.changeFrom.purplanWeight == '') {
        this.$message.error('采购吨数不能为空！')
      } else if (this.changeFrom.wharfName == '') {
        this.$message.error('港口不能为空！')
      } else if (this.changeFrom.fromOrg == '') {
        this.$message.error('供应商不能为空！')
      } else {
        if (this.changeFrom.planTempid != null && this.changeFrom.planTempid != undefined && this.changeFrom.planTempid != '') {
          for (let index = 0; index < this.plantNoByShipName.length; index++) {
            const element = this.plantNoByShipName[index]
            if (element.planTempid == this.changeFrom.planTempid) {
              this.changeFrom.planNo = element.planNo
            }
          }
        }
        this.changeFrom.remark = this.remark
        let warehouseArr = []
        let weightArr = []
        // 同时获取下拉框的valu和lable值
        // this.plantNoByShipName.forEach((item, index) => {
        //   if (this.changeFrom.planTempid == item.planTempid) {
        //     this.changeFrom.planNo = item.planNo
        //   }
        //   if(this.changeFrom.planTempid == ''){
        //     this.changeFrom.planNo = '全部'
        //   }
        // })
        // 港口
        // this.portOptions.forEach((item, index) => {
        //   if (this.changeFrom.wharfId == item.itemNo) {
        //     this.changeFrom.wharfName = item.showName
        //   }
        // })
        // this.changeFrom.wharfName = ''
        // this.baoCunData = {
        //   tPurchasePlan: this.changeFrom,
        //   warehouse: []
        // }
        let wareHouseArray = []
        this.changeTableList.forEach((item, index) => {
          const obj = {
            warehouse: item.warehouse, // 收货仓库
            purplanWarehouseId: item.id, // 计划仓库关系
            weight: item.weight // 卸货吨位
          }
          wareHouseArray.push(obj)
        })
        this.changeFrom.warehouse = wareHouseArray
        for (let index = 0; index < this.changeTableList.length; index++) {
          warehouseArr.push(this.changeTableList[index].warehouse)
          weightArr.push(this.changeTableList[index].weight)
        }
        console.log(warehouseArr, 'warehouseArr')
        // console.log(this.sum(weightArr.map(Number)))
        // this.sum(weightArr.map(Number))
        if (this.changeTableList.length > 1) {
          if (this.isRepeat(warehouseArr) == true) {
            this.$message.error('收货仓库不能重复！')
          } else if (this.sum(weightArr.map(Number)) > this.changeFrom.purplanWeight) {
            this.$confirm('当前卸货吨位之和大于采购吨数,是否保存?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => {
              this.loading = true
              savePlan(this.changeFrom).then(res => {
                this.loading = false
                this.$message.success('编辑成功！')
                this.changeMark = false
                this.getSeatchData(this.searchFrom)
              }).catch(err => {
                this.loading = false
                this.$message.error(err.message)
              })
            }).catch(() => {
              // this.$message.success("操作已撤销")
            })
          } else {
            this.loading = true
            savePlan(this.changeFrom).then(res => {
              this.loading = false
              this.$message.success('编辑成功！')
              this.changeMark = false
              this.getSeatchData(this.searchFrom)
            }).catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
          }
        } else if (this.changeTableList.length == 1) {
          if (this.sum(weightArr.map(Number)) > this.changeFrom.purplanWeight) {
            this.$confirm('当前卸货吨位之和大于采购吨数,是否保存?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => {
              this.loading = true
              savePlan(this.changeFrom).then(res => {
                this.loading = false
                this.$message.success('编辑成功！')
                this.changeMark = false
                this.getSeatchData(this.searchFrom)
              }).catch(err => {
                this.loading = false
                this.$message.error(err.message)
              })
            }).catch(() => {
              // this.$message.success("操作已撤销")
            })
          } else {
            // console.log('吨数小于，调接口')
            this.loading = true
            savePlan(this.changeFrom).then(res => {
              this.loading = false
              this.$message.success('编辑成功！')
              this.changeMark = false
              this.getSeatchData(this.searchFrom)
            }).catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
          }
        } else {
          this.$message.error('请添加收货仓库')
        }
      }
    },
    // 点击修改关闭
    changeResetForm () {
      this.changeMark = false
      this.remark = ''
      this.changeFrom = {
        purchasePlanId: '', // 采购计划ID
        purorderNo: '', // 采购订单号
        purplanNo: '', // 采购日计划号
        goodsName: '', // 物料名称
        goodsNo: '', // 物料编码
        purplanWeight: '', // 采购吨数
        startTime: '', // 交货日期
        shipName: '', // 船名
        fromOrg: '', // 供应商
        forwarderName: '', // 货代
        wharfName: '', // 港口
        wharfId: '', // 港口ID
        // planNo:'', // 疏港计划号
        planTempid: '', // 疏港计划ID
        planNo: '',
        remark: '',
        validDate: '',
        warehouse: []
      }
    }
  }
}
</script>
<style scoped lang='less'>
.el-table {
  overflow: visible !important;
}
.searchBox {
  margin-left: 25px;
}
.inpBox {
  margin: 10px 0 0 -30px;
}

// /deep/ .inpBox .el-range-editor--mini .el-input__inner {
//   width: 150px;
// }
// .inpBox .el-date-editor {
//   width: 280px !important;
// }
.searchBtnBox {
  margin-top: 10px;
  margin-left: -20px;
}
.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
.tongJi {
  display: flex;
  margin-left: 10px;
}
.tongJi_item {
  margin-right: 20px;
}
.tongJi_item span {
  color: red;
}
.addstyle{
  margin-left: 94%;
}
/deep/.el-dialog__body {
    padding: 30px 20px;
    color: #606266;
    font-size: 14px;
    background: #f5f5f5;
}
</style>
